export default "__VITE_ASSET__ZguVvI1G__"